import React, { useState, useEffect } from "react";
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import useAddInternalUserStyles from './styles';
import { AddInternalUserNew } from "../../../../services/api";

const AddInternalUsers = ({ handleTabChange }) => {
  const classes = useAddInternalUserStyles();
  const [internaluseremail, setInternalEmail] = React.useState("");
  const [internalusername, setInternalUserName] = useState("");
  const [internaluserdept, setInternalUserDept] = useState("");
  const [internaluserrole, setInternalUserRole] = useState("");
  const [internaluserpassword, setInternalUserPassWord] = useState("");
  const [internalcontactNumber, setInternalContactNumber] = useState("");
  const [isFilled, setIsFilled] = useState(false); // State to track if all fields are filled
  const [errors, setErrors] = useState({
    internalusername: "",
    internaluseremail: "",
    internaluserpassword: "",
    internalcontactNumber: "",
    internaluserdept: "",
    internaluserrole: "",
  }); // State to track errors for each field
  const token = localStorage.getItem('accessToken')

  // Function to check if all fields are filled
  useEffect(() => {
    if (internalusername && internaluseremail && internaluserpassword && internalcontactNumber && internaluserdept && internaluserrole) {
      setIsFilled(true);
    } else {
      setIsFilled(false);
    }
  }, [internalusername, internaluseremail, internaluserpassword, internalcontactNumber, internaluserdept, internaluserrole]);


  const handleAddInternalUser = () => {
    if (handleInputValidation()) {

      const Data = {
        name: internalusername,
        username: internaluseremail,
        password: internaluserpassword,
        type: 'sub_admin',
        contactNumber: internalcontactNumber,
        department: internaluserdept,
        role: internaluserrole,
      }
      AddInternalUserNew(Data, token).then((resp) => {
        if (resp?.data) {
          handleTabChange('1', '1') // Redirect to internal userlist
        } else {
        }
      })
    }
  }

  const handleUserDeptChange = (event) => {
    setInternalUserDept(event.target.value)
    setErrors({ ...errors, internaluserdept: '' })
  }

  const handleUserRoleChange = (event) => {
    setInternalUserRole(event.target.value)
    setErrors({ ...errors, internaluserrole: ''})
  }

  const handleInputValidation = () => {
    let valid = true;
    const newErrors = { ...errors };

    if (!internalusername) {
      newErrors.internalusername = "Name is required";
      valid = false;
    } else {
      newErrors.internalusername = "";
    }

    if (!internaluseremail) {
      newErrors.internaluseremail = "Email ID is required";
      valid = false;
    } else if (!isValidEmail(internaluseremail)) {
      newErrors.internaluseremail = "Email ID is invalid";
      valid = false;
    } else {
      newErrors.internaluseremail = "";
    }

    if (!internaluserpassword) {
      newErrors.internaluserpassword = "Password is required";
      valid = false;
    } else {
      newErrors.internaluserpassword = "";
    }

    if (!internalcontactNumber) {
      newErrors.internalcontactNumber = "Contact Number is required";
      valid = false;
    } else {
      newErrors.internalcontactNumber = "";
    }

    if (!internaluserdept) {
      newErrors.internaluserdept = "Department is required";
      valid = false;
    } else {
      newErrors.internaluserdept = "";
    }

    if (!internaluserrole) {
      newErrors.internaluserrole = "Hierarchy is required";
      valid = false;
    } else {
      newErrors.internaluserrole = "";
    }

    setErrors(newErrors);
    return valid;
  };

  const isValidEmail = (email) => {
    // Regular expression for email validation
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };

  return <div className={classes.root}>
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <FormControl fullWidth sx={{ m: 1 }}>
          <TextField
            id="outlined-basic"
            label="Name*"
            variant="outlined"
            value={internalusername}
            onChange={(e) => {
              setInternalUserName(e.target.value);
              setErrors({ ...errors, internalusername: "" });
            }}
            error={!!errors.internalusername}
            helperText={errors.internalusername}
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} md={6}>
        <FormControl fullWidth sx={{ m: 1 }}>
          <TextField
            id="outlined-basic"
            label="Contact No.*"
            variant="outlined"
            value={internalcontactNumber}
            onChange={(e) => {
              setInternalContactNumber(e.target.value);
              setErrors({ ...errors, internalcontactNumber: "" });
            }}
            error={!!errors.internalcontactNumber}
            helperText={errors.internalcontactNumber}
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} md={6}>
        <FormControl fullWidth sx={{ m: 1}}>
            <InputLabel id="user-dept-label">Department</InputLabel>
            <Select
              labelId = "user-dept-label"
              id="user-dept"
              value={internaluserdept}
              onChange={handleUserDeptChange}
              label="Department"
            >
              <MenuItem value="Technology">Technology</MenuItem>
              <MenuItem value="HR">HR</MenuItem>
              <MenuItem value="Marketing">Marketing</MenuItem>
              <MenuItem value="Investment">Investment</MenuItem>
              <MenuItem value="Procurement & Logistics">Procurement & Logistics</MenuItem>
              <MenuItem value="Asset Management">Asset Management</MenuItem>
              <MenuItem value="Design">Design</MenuItem>
              <MenuItem value="Finance">Finance</MenuItem>
              <MenuItem value="Pre Sales">Pre Sales</MenuItem>
              <MenuItem value="Projects">Projects</MenuItem>
              <MenuItem value="Regulatory Affairs">Regulatory Affairs</MenuItem>
            </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} md={6}>
        <FormControl fullWidth sx={{ m: 1}}>
          <InputLabel id="user-role-label">Hierarchy</InputLabel>
          <Select
            labelId = "user-role-label"
            id="user-role"
            value={internaluserrole}
            onChange={handleUserRoleChange}
            label="Hierarchy"
          >
            <MenuItem value="Director">Director</MenuItem>
            <MenuItem value="Manager">Manager</MenuItem>
            <MenuItem value="Employee">Employee</MenuItem>
          </Select>
          {errors.internaluserrole && <p style={{ color: 'red', fontSize: '0.75rem' }}>{errors.internaluserrole}</p>}
        </FormControl>
      </Grid>
      <Grid item xs={12} md={6}>
        <FormControl fullWidth sx={{ m: 1 }}>
          <TextField
            id="outlined-basic"
            label="Email ID*"
            variant="outlined"
            value={internaluseremail}
            onChange={(e) => {
              setInternalEmail(e.target.value);
              setErrors({ ...errors, internaluseremail: "" });
            }}
            error={!!errors.internaluseremail}
            helperText={errors.internaluseremail}
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} md={6}>
        <FormControl fullWidth sx={{ m: 1 }}>
          <TextField
            id="outlined-basic"
            label="Password*"
            variant="outlined"
            value={internaluserpassword}
            onChange={(e) => {
              setInternalUserPassWord(e.target.value);
              setErrors({ ...errors, internaluserpassword: "" });
            }}
            error={!!errors.internaluserpassword}
            helperText={errors.internaluserpassword}
          />
        </FormControl>
      </Grid>
    </Grid>
    <button
      onClick={handleAddInternalUser}
      className={`save_btn ${isFilled ? "" : "disabled"}`}
      disabled={!isFilled} // Disable button if not all fields are filled
    >
      Save
    </button>
  </div>
};

AddInternalUsers.propTypes = {};

export default AddInternalUsers;
